export const BondStatus = {
    UnBonded: 'UnBonded',
    UnBonding: 'UnBonding',
    Bonded: 'Bonded',
};
